<template>
    <div>
        <external-ad-iframe v-if="ad_config.is_enabled" :external_ad_id="ad_config.external_id"></external-ad-iframe>
        <nsw-banner v-else ref="nsw"></nsw-banner>
        <nsw-menu></nsw-menu>
        <div class="content-wrapper updated-2026">
            <nsw-module class="nsw-module"></nsw-module>
            <nsw-news class="nsw-news"></nsw-news>
        </div>
<!--        <consent-dialog-->
<!--            :visible="showTerms"-->
<!--            @agree="agreeTerms"-->
<!--            @disagree="rejectTerms"-->
<!--            @close="rejectTerms"-->
<!--        >-->
<!--            <popup-terms-content></popup-terms-content>-->
<!--        </consent-dialog>-->
    </div>
</template>
<script>

    import Vue from 'vue';
    import axios from 'axios';
    import api from '@js/api';
    import router from '@js/routes';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import {mapState, mapGetters} from 'vuex';
    import EventBus from '@common/eventBus';
    import {checkViewCount} from '@mixins/checkViewCount';



    export default {
        name:"Home",
        mixins:[common,storeMapper, checkViewCount],
        data() {
            return {
                showTerms: false,
                ad_config: window.ad_config,
                resizeHandler: null,
                pageOverflowLockHandler: null
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm=>{
                EventBus.$emit("showGlobalLoading");

                Promise.all(
                    [
                        api.getMainCate(),
                        api.getBanner(),
                        api.getDownloadData(),
                        api.getMpmsSystemMsg(mpms_get_system_msg_url),
                        api.getWebsitePopup()
                    ]
                //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                //If something has to be processed when error returns, place the logic in catch block instead
                .map(p => p.catch(() => undefined)))
                .then(axios.spread((responseMainCate, responseBanner, responseDownloadData, mpms_resp, popup_resp) => {

                        if (responseMainCate) {
                            vm.setWebSiteAndCate( responseMainCate.data, vm);
                        }
                        if (responseBanner) {
                            vm.$store.commit('banner/setBanner', responseBanner.data);
                        }

                        if (responseDownloadData) {
                            vm.$store.commit("my_download_store/updateData", responseDownloadData.data);

                            responseDownloadData.data.zip_list.forEach(function(item) {
                                if (!item.finished_zip) {
                                    let id = item.id.$oid;
                                    EventBus.$emit("checkDownloadStatus", id);
                                }
                            });
                        }

                        if (mpms_resp) {
                            if (mpms_resp.data.length > 0) {

                                if (vm.isShowPopup(mpms_popup_id)) {
                                    let msg = [];
                                    mpms_resp.data.forEach(function(item) {

                                        if (item.msg) {
                                            item.msg.forEach(function(obj) {
                                                if (obj.lang === website_lang) {
                                                    msg.push(obj.txt);
                                                }
                                            });
                                        }

                                    });

                                    EventBus.$emit("showHkepMsgPop", msg);

                                    vm.initViewCount(mpms_popup_id);

                                }

                            }

                        }

                        if (popup_resp) {
                            if (popup_resp.data) {
                                EventBus.$emit("show_hkep_popup", popup_resp.data[0]);

                            }
                        }

                        // Start banner carousel after banner data is committed
                        Vue.nextTick(() => {
                            if (vm.$refs.nsw && typeof vm.$refs.nsw.startCarousel === 'function') {
                                vm.$refs.nsw.startCarousel();
                            }
                        });

                        //TODO: Handle MathJax in common  place, e.g. mixins
                        Vue.nextTick(()=>{
                            if(window.MathJax) {
                                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => {
                                    EventBus.$emit("hideGlobalLoading");
                                });
                            }
                        });

                    }))
                    /*.catch(error=>{
                        //Handle errors here if something is expected to precess here
                    });
                    */
                    vm.getAgreeTerms();
                })

        },
        computed: {

        },
        mounted() {
            var content_wrapper = this.$el.querySelector(".content-wrapper.updated-2026");
            var updateContentWrapperHeight = function() {
                if (!content_wrapper) {
                    return;
                }
                // 768px 以上固定 content-wrapper 高度為 100vh
                if (window.matchMedia("(min-width: 768px)").matches) {
                    content_wrapper.style.height = "100vh";
                    content_wrapper.style.maxHeight = "100vh";
                } else {
                    content_wrapper.style.height = "";
                    content_wrapper.style.maxHeight = "";
                }
            };
            var updatePageOverflowLock = function() {
                // 允許 content-wrapper 撐開整頁時使用整頁捲動
                document.body.style.overflow = "";
            };

            this.resizeHandler = updateContentWrapperHeight;
            this.pageOverflowLockHandler = updatePageOverflowLock;
            this.$nextTick(function() {
                updateContentWrapperHeight();
                setTimeout(updateContentWrapperHeight, 0);
                setTimeout(updateContentWrapperHeight, 300);
            });
            window.addEventListener("resize", this.resizeHandler);
            window.addEventListener("resize", this.pageOverflowLockHandler);
            EventBus.$on("hideGlobalLoading", updateContentWrapperHeight);
            this._homeHeightUpdater = updateContentWrapperHeight;
            updatePageOverflowLock();

        },
        beforeDestroy() {
            if (this.resizeHandler) {
                window.removeEventListener("resize", this.resizeHandler);
            }
            if (this.pageOverflowLockHandler) {
                window.removeEventListener("resize", this.pageOverflowLockHandler);
            }
            if (this._homeHeightUpdater) {
                EventBus.$off("hideGlobalLoading", this._homeHeightUpdater);
            }
            document.body.style.overflow = "";
        },
        methods: {
            getAgreeTerms() {
                let self = this;
                api.getConsents(mpms_api_domain_name).then(function (res) {
                    if (res.data.needs_reagree) {
                        self.showTerms = res.data.needs_reagree;
                    }
                }).catch(function (){
                    self.showTerms = false;
                })
            },
            agreeTerms() {
                let self = this;
                api.saveConsent(mpms_api_domain_name).then(resp=> {
                    self.showTerms = false;
                }).catch(function (resp){
                    self.showTerms = false;
                }).finally(function (){
                    self.showTerms = false;
                });
            },
            rejectTerms() {
                EventBus.$emit("showGlobalLoading");
                let self = this;

                api.userLogout().then(resp=> {
                    self.showTerms = false;
                    var url = window.location.protocol+"//"+window.location.host;

                    window.location.href = url;
                    EventBus.$emit("hideGlobalLoading");
                }).catch(function (resp) {
                    self.showTerms = false;
                    EventBus.$emit("hideGlobalLoading");
                }).finally(function (){
                    self.showTerms = false;
                });
            }
        }

    }
</script>

<style scoped lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";

    .content-wrapper {
        overflow: hidden;
    }

    .content-wrapper.#{'updated-2026'} {

        overflow: hidden;
        flex-wrap: wrap-reverse;
        display: flex;
        gap: 20px;

        .nsw-module {
            width: 100%;
        }

        .nsw-news {
            width: 100%;
        }

        // 小於 640px：整頁捲動，不在各區塊內捲動
        @media (max-width: 639px) {
            overflow: visible;
            height: auto;
            max-height: none;
            min-height: 0;

            .nsw-module,
            .nsw-news {
                overflow: visible;
                height: auto;
                max-height: none;
                min-height: 0;
            }
        }

        // 640px breakpoint
        @media (min-width: 640px) {
            flex-wrap: wrap-reverse;
            .nsw-module {
                width: 100%;
            }

            .nsw-news {
                width: 100%;
            }
        }

        // 768px breakpoint
        @media (min-width: 768px) {
            flex-wrap: nowrap;
            min-height: 0;
            height: 100%;
            max-height: 100%;

            .nsw-module {
                width: 60%;
                height: 100%;
                max-height: 100%;
                min-height: 0;
                overflow-y: auto;
            }

            .nsw-news {
                width: 40%;
                height: 100%;
                max-height: 100%;
                min-height: 0;
                overflow-y: auto;
            }
        }

        // 1024px breakpoint
        @media (min-width: 1024px) {
            flex-wrap: nowrap;
            .nsw-module {
                width: 67%;
                min-height: 0;
                height: 100%;
                max-height: 100%;
                overflow-y: auto;
            }

            .nsw-news {
                width: 33%;
                min-height: 0;
                height: 100%;
                max-height: 100%;
                overflow-y: auto;
            }
        }
    }




</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Home.vue